import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";

import { isManagedBackendUrl } from "../backend-request-url.util";

@Injectable()
export class CredentialsInterceptorService implements HttpInterceptor {
  public intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (!isManagedBackendUrl(request.url) || request.withCredentials) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        withCredentials: true,
      }),
    );
  }
}
